import { Page } from '@/core/architecture'

import { DeactivationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * Deactivation Page
 * Implemented as a practical sample.
 */
export const Deactivation: Page = () => {
  const { state, actions } = useViewModel()

  return <DeactivationTemplate state={state} {...actions} />
}
